export enum DataSecurityAppActiveStatusType {
	Unknown = 'unknown',
	Operational = 'operational',
	Minor = 'minor',
	Major = 'major',
	Critical = 'critical'
}

export type DataSecurityAppActiveStatus = {
	applicationId: number;
	applicationLabel: string;
	applicationName: string;
	errorMessage: string;
	status: DataSecurityAppActiveStatusType;
	statusPageUrl: string;
};
